import { useCallback } from "react";
import { serviceRegistry } from "@/services/ServiceRegistry";
import type { BaseService } from "@/services/BaseService";
import type { IRoomService } from "@/services/interfaces/IRoomService";

export const useServices = () => {
  const getService = useCallback(<T extends BaseService>(name: string): T => {
    return serviceRegistry.getService<T>(name);
  }, []);

  const setAuthToken = useCallback((token: string) => {
    serviceRegistry.setAuthToken(token);
  }, []);

  const clearAuthToken = useCallback(() => {
    serviceRegistry.clearAuthToken();
  }, []);

  const setGlobalHeaders = useCallback((headers: Record<string, string>) => {
    serviceRegistry.setGlobalHeaders(headers);
  }, []);

  const getServiceNames = useCallback(() => {
    return serviceRegistry.getServiceNames();
  }, []);

  const hasService = useCallback((name: string) => {
    return serviceRegistry.hasService(name);
  }, []);

  return {
    getService,
    setAuthToken,
    clearAuthToken,
    setGlobalHeaders,
    getServiceNames,
    hasService,
    roomService: serviceRegistry.getRoomService(),
  };
};

export const useRoomService = (): IRoomService => {
  return serviceRegistry.getRoomService();
};
